export default // eslint-disable-next-line max-len
'<svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20"><path fill-rule="evenodd" d="M15.172 5.963H8a6.014 6.014 0 0 0 0 12.028h9v2h-9a8.018 8.018 0 0 1 0-16.036h7.172l-2.536-2.542L14.05 0l4.95 4.961-4.95 4.961-1.414-1.417z"/></svg>';
